gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function(){
    $('.c-intro-section').imagesLoaded(function () {
        [".c-section__title", ".c-page-top__title", ".c-section__content", ".c-site-footer__logo", ".c-site-footer__top", ".c-link--down", ".c-page-top__intro", '.c-news-slider-arrows-container'].forEach(function (el) {
            $(el).each(function (id) {
                $(this).css({
                    "animation-delay": 0.15 * id + "s"
                });
            });
        });
    
        [".c-intro-section .c-social-menu", ".c-page-top .c-social-menu", ".c-section__controls", ".c-section__header", ".c-news-slider", ".general-reg-list", ".c-person-slider", ".c-brand-list"].forEach(function (el) {
            $(el).each(function (id) {
                $(this).find("li, .c-btn--more, .slick-arrow, .c-news-item, .g-reg-item, .c-person, .c-brand img").each(function (id) {
                    $(this).css({
                        "animation-delay": 0.15 * (id + 1) + "s"
                    });
                });
            });
        });
    
        var $animateElements = $('.c-intro-section .c-social-menu')
            .add('.c-page-top .c-social-menu')
            // .add('.c-intro-section__title')
            //.add('.c-intro-section__controls')
            .add('.c-news-slider')
            .add('.general-reg-list')
            .add('.c-person-slider')
            .add('.c-brand-list')
            .add('.c-link--down')
            .add('.c-page-top__intro')
            .add('.c-page-top__title')
            .add('.c-site-footer__logo')
            .add('.c-section__header')
            .add('.c-section__title')
            .add('.c-section__content')
            .add('.c-section__controls')
            .add('.c-site-copyrights')
            .add('.c-site-author')
            .add('.c-site-footer__top')
            .add('.c-news-slider-arrows-container');
        // .add('.c-team-wrapper')
        // .add('.c-items-grid')
        // .add('.c-model-grid')
        // .add('.c-article-list')
        // .add('.c-accessories-grid')
        // .add('.c-person-list')
        // .add('.c-model-list')
        // .add('.c-cta-grid')
        // .add('.c-features-list')
        // .add('.c-tab-content')
        // .add('.c-advanced-gallery')
        // .add('.c-car-list-item')
        // .add('.c-intro-section > .h-site-block .c-intro-section__content');
    
        gsap.utils.toArray($animateElements).forEach(function (txt) {
            ScrollTrigger.create({
                trigger: txt,
                end: "bottom top",
                start: "top bottom",
                onEnter: function (el, st) {
                    $(txt).addClass("h-is-animated");
                },
                onEnterBack: function (el, st) {
                    $(txt).addClass("h-is-animated");
                },
                //markers: true
            });
        });
    
        // var b1 = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: $(".c-flying-bubble--1"),
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: true,
        //         //markers: true
        //     }
        // });
        //
        // b1.fromTo(".c-flying-bubble--1", {y: '40%'}, {y: '0'});
        //
        // var b2 = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: $(".c-flying-bubble--2"),
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: true,
        //         //markers: true
        //     }
        // });
        //
        // b2.fromTo(".c-flying-bubble--2", {y: '20%'}, {y: '-20%'});

        if($(".c-flying-bubble--3").length){
            var b3 = gsap.timeline({
                scrollTrigger: {
                    trigger: $(".c-flying-bubble--3"),
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    //markers: true
                }
            });

            b3.fromTo(".c-flying-bubble--3", {y: '25%'}, {y: '-15%'});
        }

        if($(window).width() >= 992){
            if($(".body-left").length){
                var f1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: $(".body-left"),
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        // markers: true
                    }
                });

                f1.fromTo(".body-left", {y: '100%'}, {y: '0%'});
            }

            if($(".corner-box-bottom-right").length){
                var f2 = gsap.timeline({
                    scrollTrigger: {
                        trigger: $(".corner-box-bottom-right"),
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        // markers: true
                    }
                });

                f2.fromTo(".corner-box-bottom-right", {y: '-50%'}, {y: '-10%'});
            }

            if($(".corner-box-bottom-left").length){
                var f3 = gsap.timeline({
                    scrollTrigger: {
                        trigger: $(".corner-box-bottom-left"),
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        // markers: true
                    }
                });

                f3.fromTo(".corner-box-bottom-left", {y: '-50%'}, {y: '-10%'});
            }

            if($(".header-bottom-right").length){
                var f4 = gsap.timeline({
                    scrollTrigger: {
                        trigger: $(".header-bottom-right"),
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        // markers: true
                    }
                });

                f4.fromTo(".header-bottom-right", {y: '30%'}, {y: '-30%'});
            }

            if($(".corner-box-top-right").length){
                var f5 = gsap.timeline({
                    scrollTrigger: {
                        trigger: $(".corner-box-top-right"),
                        start: "top center",
                        end: "bottom top",
                        scrub: true,
                        // markers: true
                    }
                });

                f5.fromTo(".corner-box-top-right", {y: '-15%'}, {y: '25%'});
            }
        }


        // gsap.utils.toArray($(".c-sticky-decoration svg")).forEach(function (txt) {
        //     console.log(txt);
        //     let tml = gsap.timeline({
        //         scrollTrigger: {
        //             trigger: txt,
        //             start: "top bottom",
        //             end: "bottom top",
        //             scrub: true,
        //             //markers: true
        //         }
        //     });
        //     tml.fromTo(txt, {y: '25%'}, {y: '-25%'});
        // });
    });
});
